import { render } from "./columnChart.vue?vue&type=template&id=0ef095c0"
import script from "./columnChart.vue?vue&type=script&lang=js"
export * from "./columnChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__